import React, { useEffect, useState } from "react";
import { InputNumber } from "antd";
import { Currency } from "../../Payment/MultiplePaymentApp";
import ApiService from "../../../core/service/ApiService";
import CurrencySelect from "../../../core/components/CurrencySelect";

export const AppointmentEntitlementInput = ({ row, onSuccess }) => {
    const [data, setData] = useState({
        currency: 'TRY',
        amount: 0
    })

    useEffect(() => {
        setData({
            currency: row.entitlementCurrency || row.currency,
            amount: row.entitlementAmount
        })
    }, [row]);

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <InputNumber
                size={'small'}
                disabled={row?.confirmStatus === 2}
                value={data.amount}
                prefix={Currency[data.currency]}
                onPressEnter={async (e) => {
                    setData({
                        ...data,
                        amount: e.target.value
                    })
                    const res = await ApiService.Entitlement.UpdateEntitlement(row.appointmentId, {
                        amount: e.target.value,
                        currency: data.currency,
                        type: 'amount'
                    });

                    if (res.success) {
                        await onSuccess()
                    }
                }}
            />
            <CurrencySelect
                short={true}
                size={'small'}
                disabled={row?.confirmStatus === 2}
                value={data.currency}
                onChange={(e) => {
                    setData({
                        ...data,
                        currency: e,
                    })
                }}
            />
        </div>
    )
}